import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * 菜单
 * */
import { cloneDeep } from 'lodash';
import BasicLayout from '@/layouts/basic-layout';
import { includeArray, setNativeMenuSider, setNativeMenuHeader, getHeaderName, getMenuSider, getSiderSubmenu, getNativeMenuSider, getNativeMenuHeader } from '@/libs/system';
import Tool from '@/utils/tool';
import router from '@/router';
import { MenuList, RouterList } from '@api/system/menu';
import Setting from '@/setting';
import menuSider from '@/menu/sider';
import headerMenu from '@/menu/header';
import siderMenu from '@/menu/sider';
var errorPage = [{
  path: '/403',
  name: '403',
  meta: {
    title: '403',
    hidden: true
  },
  component: function component() {
    return import('@/sys-pages/system/error/403');
  }
}, {
  path: '/500',
  name: '500',
  meta: {
    title: '500',
    hidden: true
  },
  component: function component() {
    return import('@/sys-pages/system/error/500');
  }
}, {
  path: '/:pathMatch(.*)',
  name: '404',
  meta: {
    title: '404',
    hidden: true
  },
  component: function component() {
    return import('@/sys-pages/system/error/404');
  }
}];

// 根据 menu 配置的权限，过滤菜单
function filterMenu(menuList, access, lastList) {
  menuList.forEach(function (menu) {
    var menuAccess = menu.auth;
    if (!menuAccess || includeArray(menuAccess, access)) {
      var newMenu = {};
      for (var i in menu) {
        if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
      }
      if (menu.children && menu.children.length) newMenu.children = [];
      lastList.push(newMenu);
      menu.children && filterMenu(menu.children, access, newMenu.children);
    }
  });
  return lastList;
}
function handleRouter(routerList) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return routerList.filter(function (route) {
    if (parent) {
      route.component = BasicLayout;
    } else {
      route.component = loadView(route.component);
    }
    if (route.children && route.children.length > 0) {
      route.children = handleRouter(route.children, false);
    }
    return true;
  });
}
function loadView(path) {
  // 路由懒加载
  return function () {
    return import("@/pages/".concat(path));
  };
}
export default {
  namespaced: true,
  state: {
    // 顶部菜单
    header: [],
    // 侧栏菜单
    sider: [],
    // 当前顶栏菜单的 name
    headerName: '',
    // 当前所在菜单的 path
    activePath: '',
    // 展开的子菜单 name 集合
    openNames: [],
    // 所有的菜单
    menuSider: [],
    allSider: null,
    // 侧边菜单徽标
    siderMenuBadge: Setting.badge.siderMenuBadge,
    // 顶栏菜单徽标
    headerMenuBadge: Setting.badge.headerMenuBadge,
    // 是否获取过路由信息
    hasGetRouter: false,
    // 动态路由
    dynamicRouters: []
  },
  getters: {
    /**
     * @description 根据 user 里登录用户权限，对侧边菜单进行鉴权过滤
     * */
    filterSider: function filterSider(state, getters, rootState) {
      var userInfo = rootState.admin.user.info;
      // @权限
      var access = userInfo.access || [];
      if (Setting.layout.headerHide.headerMenu) {
        return filterMenu(state.sider, access, []);
      } else {
        return filterMenu(state.allSider, access, []);
      }
    },
    /**
     * @description 根据 user 里登录用户权限，对顶栏菜单进行鉴权过滤
     * */
    filterHeader: function filterHeader(state, getters, rootState) {
      var userInfo = rootState.admin.user.info;
      // @权限
      var access = userInfo.access;
      if (access && access.length) {
        return state.header.filter(function (item) {
          var state = true;
          if (item.auth && !includeArray(item.auth, access)) state = false;
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              if (child.auth && !includeArray(child.auth, access)) state = false;
              return state;
            });
          }
          return state;
        });
      } else {
        return state.header.filter(function (item) {
          var state = true;
          if (item.auth && item.auth.length) state = false;
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              if (child.auth && child.auth.length) state = false;
              return state;
            });
          }
          return state;
        });
      }
    },
    /**
     * @description 当前 header 的全部信息
     * */
    currentHeader: function currentHeader(state) {
      return state.header.find(function (item) {
        return item.name === state.headerName;
      });
    },
    /**
     * @description 在当前 header 下，是否隐藏 sider（及折叠按钮）
     * */
    hideSider: function hideSider(state, getters) {
      var visible = false;
      if (getters.currentHeader) {
        if ('hideSider' in getters.currentHeader) {
          visible = getters.currentHeader && getters.currentHeader.hideSider;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
      return visible;
    }
  },
  mutations: {
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setSider: function setSider(state, menu) {
      state.sider = menu;
    },
    /**
     * @description 设置顶栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setHeader: function setHeader(state, menu) {
      state.header = menu;
    },
    /**
     * @description 设置当前顶栏菜单 name
     * @param {Object} state vuex state
     * @param {Array} name headerName
     */
    setHeaderName: function setHeaderName(state, name) {
      state.headerName = name;
    },
    /**
     * @description 设置当前所在菜单的 path，用于侧栏菜单高亮当前项
     * @param {Object} state vuex state
     * @param {Array} path fullPath
     */
    setActivePath: function setActivePath(state, path) {
      state.activePath = path;
    },
    /**
     * @description 设置当前所在菜单的全部展开父菜单的 names 集合
     * @param {Object} state vuex state
     * @param {Array} names openNames
     */
    setOpenNames: function setOpenNames(state, names) {
      state.openNames = names;
    },
    /**
     * @description 设置所有菜单
     * @param {Object} state vuex state
     * @param {Array} menuSider menuSider
     * */
    setMenuSider: function setMenuSider(state, menuSider) {
      state.menuSider = menuSider;
    },
    setAllSider: function setAllSider(state, allSider) {
      state.allSider = allSider;
    },
    /**
     * @description 设置全部的侧边菜单的徽标
     * */
    setAllSiderMenuBadge: function setAllSiderMenuBadge(state, data) {
      state.siderMenuBadge = data;
    },
    /**
     * @description 新增或修改某个侧边菜单的徽标
     * */
    setSiderMenuBadge: function setSiderMenuBadge(state, _ref) {
      var path = _ref.path,
        badge = _ref.badge;
      var siderMenuBadge = cloneDeep(state.siderMenuBadge);
      var menuIndex = siderMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) {
        siderMenuBadge[menuIndex] = badge;
        state.siderMenuBadge = siderMenuBadge;
      } else {
        state.siderMenuBadge.push(badge);
      }
    },
    /**
     * @description 删除某个侧边菜单的徽标
     * */
    removeSiderMenuBadge: function removeSiderMenuBadge(state, path) {
      var menuIndex = state.siderMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) state.siderMenuBadge.splice(menuIndex, 1);
    },
    /**
     * @description 设置全部的顶栏菜单的徽标
     * */
    setAllHeaderMenuBadge: function setAllHeaderMenuBadge(state, data) {
      state.headerMenuBadge = data;
    },
    /**
     * @description 新增或修改某个顶栏菜单的徽标
     * */
    setHeaderMenuBadge: function setHeaderMenuBadge(state, _ref2) {
      var path = _ref2.path,
        badge = _ref2.badge;
      var headerMenuBadge = cloneDeep(state.headerMenuBadge);
      var menuIndex = headerMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) {
        headerMenuBadge[menuIndex] = badge;
        state.headerMenuBadge = headerMenuBadge;
      } else {
        state.headerMenuBadge.push(badge);
      }
    },
    /**
     * @description 删除某个顶栏菜单的徽标
     * */
    removeHeaderMenuBadge: function removeHeaderMenuBadge(state, path) {
      var menuIndex = state.headerMenuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) state.headerMenuBadge.splice(menuIndex, 1);
    },
    /**
     * 设置是否获取过路由信息
     * @param state
     * @param hasGetRouter
     */
    setHasGetRouter: function setHasGetRouter(state, hasGetRouter) {
      state.hasGetRouter = hasGetRouter;
    },
    /**
     * 设置动态路由（从服务器加载到的路由信息）
     * @param state
     * @param routers
     */
    setDynamicRouters: function setDynamicRouters(state, routers) {
      state.dynamicRouters = routers;
    }
  },
  actions: {
    /**
     * @description 设置菜单（动态+静态）
     * */
    setMenuList: function setMenuList(_ref3) {
      var state = _ref3.state,
        dispatch = _ref3.dispatch,
        commit = _ref3.commit,
        rootState = _ref3.rootState;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // 只动态菜单设置顶栏菜单
      if (Setting.dynamicMenu) {
        // 设置顶栏菜单
        var menuHeaderList = getNativeMenuHeader();
        commit('setHeader', menuHeaderList);
      }
      // 设置侧边栏菜单
      var menuSiderList = Setting.dynamicMenu ? getNativeMenuSider() : _toConsumableArray(menuSider);
      // let path = to.matched[to.matched.length - 1].path;
      var path = to.path;
      var headerName = getHeaderName(path, menuSiderList);
      if (headerName === null) {
        path = to.path;
        headerName = getHeaderName(path, menuSiderList);
      }
      // 在 404 时，是没有 headerName 的
      if (headerName !== null) {
        commit('setHeaderName', headerName);
        commit('setMenuSider', menuSiderList);
        var userInfo = rootState.admin.user.info;
        // @权限
        var access = userInfo.access;
        var headerList = Tool.clone(state.header);
        var header = headerList.filter(function (item) {
          var state = true;
          if (item.auth && !includeArray(item.auth, access)) state = false;
          if (item.name === 'home') {
            state = true;
          }
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              if (child.auth && !includeArray(child.auth, access)) state = false;
              return state;
            });
          }
          return state;
        });
        var sider = filterMenu(state.menuSider, [].concat(_toConsumableArray(access), ["hidden"]), []);
        var allSider = header.map(function (menu) {
          var children = sider.filter(function (item) {
            return menu.name === item.header;
          });
          menu.children = children;
          return menu;
        });
        commit('setAllSider', allSider);
        var filterMenuSider = getMenuSider(menuSiderList, headerName);
        commit('setSider', filterMenuSider);
        commit('setActivePath', to.path);
        var openNames = getSiderSubmenu(path, allSider);
        commit('setOpenNames', openNames);
      }
    },
    /**
     * @description 动态获取菜单
     * @param dispatch
     * @param loadMenu 是否加载菜单，需传 $route 信息
     * */
    getMenuList: function getMenuList(_ref4, loadMenu) {
      var dispatch = _ref4.dispatch;
      return new Promise(function (resolve, reject) {
        MenuList().then(function (res) {
          var header = _toConsumableArray(headerMenu);
          if (res.data.header && res.data.header.length) {
            header.push.apply(header, _toConsumableArray(res.data.header));
          }
          var sider = _toConsumableArray(siderMenu);
          if (res.data.sider && res.data.sider.length) {
            sider.push.apply(sider, _toConsumableArray(res.data.sider));
          }
          setNativeMenuHeader(header);
          setNativeMenuSider(sider);
          if (loadMenu) {
            var to = loadMenu === true ? router.currentRoute.value : loadMenu;
            dispatch('setMenuList', to);
          }
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    getRouters: function getRouters(_ref5, to) {
      var dispatch = _ref5.dispatch,
        commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        // 向后端请求路由数据
        RouterList().then(/*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(result) {
            var accessedRoutes;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  accessedRoutes = handleRouter(result.data);
                  commit('setDynamicRouters', result.data);
                  accessedRoutes.push.apply(accessedRoutes, errorPage);
                  accessedRoutes.forEach(function (route) {
                    router.addRoute(route);
                  });
                  // 获取动态菜单
                  if (!Setting.dynamicMenu) {
                    _context.n = 1;
                    break;
                  }
                  _context.n = 1;
                  return dispatch('admin/menu/getMenuList', to, {
                    root: true
                  });
                case 1:
                  commit('setHasGetRouter', true);
                  resolve(accessedRoutes);
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref6.apply(this, arguments);
          };
        }()).catch(function (err) {
          reject(err);
        });
      });
    },
    getMenu: function getMenu(_ref7) {
      var state = _ref7.state;
      return new Promise(function (resolve) {
        resolve(state.menuSider);
      });
    }
  }
};